import { PopoverPanelProps } from "@headlessui/react"

import { classNames } from "../../../../lib/classNames"

export const basepopoverClassName = [
  "bg-v2-background-elevation-overlay",
  "border border-v2-border-default",
  "w-full",
  "rounded-overlay",
  "shadow-v2-overlay",
  "overflow-hidden",
]

export const popoverClassName = classNames(...basepopoverClassName, "z-10")
export const modalPopoverClassName = classNames(
  ...basepopoverClassName,
  "z-[60]"
)

export const popoverRowClassName = classNames(
  "flex items-center rounded-control",
  "color-default text-body-lg",
  "hover:bg-v2-background-surface-strong",
  "active:bg-v2-background-surface-stronger",
  "px-2 min-h-8",
  "cursor-pointer"
)

export const popoverRowDisabledClassName = classNames(
  "!bg-gray-300 dark:!bg-gray-600",
  "!text-gray-500 dark:!text-gray-400",
  "!cursor-default",
  "!opacity-100",
  "hover:!bg-gray-300 dark:hover:!bg-gray-600"
)

export const popoverPanelAnchor: PopoverPanelProps["anchor"] = {
  to: "bottom start",
  gap: 4,
  padding: 4,
}

export const popoverPanelAnchorEnd: PopoverPanelProps["anchor"] = {
  to: "bottom end",
  gap: 4,
  padding: 4,
}
